module.exports = __webpack_public_path__ + "img/brand_04.119882f9.png";